import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
//import { CloseButton } from "react-bootstrap";
import MainAside from "./MainAside";
import SubAside from "./sub-aside/SubAside";
import BottomMenu from "./BottomMenu";
import logo from  "../../assets/media/logos/fiducia/fd-isotipo-color.svg"
import ClickOutside from "../helpers/ClickOutside";
export const useScreenSize = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        return () => {
          window.removeEventListener("resize", handleResize);
        };
      }, []);

      return width;
};

export default function Aside({
  navSm,
  setNavSm
}) {

  const [active, setActive] = useState(true);
  const width = useScreenSize();

  useEffect(() => {
      const body = document.body;

      if (width <= 1199.98) {
          body.setAttribute("data-kt-aside-minimize", "on");
          setActive(false);
      }

  }, [width]);

    function activeAside() {
        const body = document.body;

        if (body.hasAttribute("data-kt-aside-minimize")) {
            body.removeAttribute("data-kt-aside-minimize");
            setActive(true);
        } else {
            body.setAttribute("data-kt-aside-minimize", "on");
            setActive(false);
        }
    }

  return (
      <>
        <ClickOutside onClick={() => setNavSm(false)}>
          <aside className={"aside aside-extended " + (navSm ? 'drawer drawer-start drawer-on' : '')}>
            <div className="aside-primary d-flex flex-column align-items-lg-center flex-row-auto border-end">
              <div className="aside-logo d-none d-lg-flex flex-column align-items-center flex-column-auto pb-3 pt-4" id="aside_logo">
                <Link to={'/dashboard'}>
                  <img alt="Logo" src={logo} style={{height: 48 + "px"}}/>
                </Link>
              </div>
              <MainAside ></MainAside>
              <BottomMenu></BottomMenu>
            </div>
            <SubAside></SubAside>
            <button id="kt_aside_toggle"
                    type={'button'}
                    className={"aside-toggle btn btn-sm btn-icon bg-body btn-color-gray-700 btn-active-primary position-absolute translate-middle start-100 end-0 bottom-0 shadow-sm d-none d-lg-flex mb-5 " + (active ? '' : 'active')}
                    onClick={activeAside}
            >
              <i className="ki-outline ki-arrow-left fs-2 rotate-180"></i>
            </button>
          </aside>
        </ClickOutside>
      </>
  );
}
